import { LINK_TARGETS } from '@ratehub/base-ui';

// This was moved from `web-components` to `base-ui`.
// This file remains to reduce the diff of the move.

export default LINK_TARGETS;
